/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto } from '../models/Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TwoFactorPurposeService {

    /**
     * @returns Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppTwoFactorPurpose(): CancelablePromise<Array<Wealthlane_Dtos_TwoFactor_TwoFactorPurposeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/two-factor-purpose',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
